<template>
  <div id="app" :class="{ 'is-watch': isWatchLayout }" @touchstart="touchStart($event)" @touchend="touchEnd($event)">
    <router-view v-if="isWatchLayout"></router-view>
    <homePages v-else></homePages>
    <waitingB
      v-if="!isWatchLayout && isGetPhone"
      class="waitingB"
      :userA="userA"
      :baiban_id="baiban_id"
      @getShow="getShow"
    />
  </div>
</template>
<script>
  import { getIsPhone } from '@/api/userServices'
  import { getDeviceType } from '@/utils/device'
  import HomePages from './pages/homePages/index.vue'

  export default {
    data() {
      return {
        timer: '',
        isGetPhone: false,
        userA: {},
        baiban_id: '',
        isWatchDevice: false,
      }
    },
    computed: {
      isWatchLayout() {
        return this.isWatchDevice || this.$route.path.startsWith('/watch')
      },
    },
    created() {
      this.isWatchDevice = getDeviceType() === 'watch'
      this.fbiSF()
      this.getPhoneType()
    },
    mounted() {
      if (this.isWatchDevice) return

      this.timer = setInterval(() => {
        this.getPhone()
      }, 5000)
    },
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer)
    },
    components: {
      homePages: HomePages,
      waitingB: () => import('@/pages/recordDetail/waitingB'),
    },
    methods: {
      isSwipeBackDisabledPath(path) {
        return ['/BloodSugar', '/ReportCenter', '/aiAssistant', '/inquiry', '/MineView'].includes(path)
      },
      getShow() {
        this.isGetPhone = false
      },
      getPhone() {
        const appuser = localStorage.getItem('appuser')
        if (appuser) {
          const params = {
            uid: JSON.parse(appuser).id,
          }
          getIsPhone(params).then(res => {
            if (!res.data.data) {
              this.isGetPhone = false
            } else {
              if (!res.data.data.baiban.statusb) {
                this.isGetPhone = true
                this.userA = res.data.data.userA
                this.baiban_id = res.data.data.baiban.baiban_id
              } else if (res.data.data.baiban.statusb == 1) {
                if (this.$route.path != '/baiban') {
                  this.$router.replace({
                    path: 'baiban',
                    query: {
                      baibanId: res.data.data.baiban.baiban_id,
                    },
                  })
                }
              }
            }
          })
        }
      },
      getPhoneType() {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

        if (isAndroid) {
          //Android
          localStorage.setItem('phoneType', 'Android')
        } else if (isiOS) {
          //ios
          localStorage.setItem('phoneType', 'ios')
        } else {
          localStorage.setItem('phoneType', 'web')
        }
      },
      fbiSF() {
        document.documentElement.addEventListener(
          'touchstart',
          function (event) {
            if (event.touches.length > 1) {
              event.preventDefault()
            }
          },
          { passive: false }
        )

        let lastTouchEnd = 0
        document.documentElement.addEventListener(
          'touchend',
          function (event) {
            const now = Date.now()
            if (now - lastTouchEnd <= 300) {
              event.preventDefault()
            }
            lastTouchEnd = now
          },
          { passive: false }
        )
      },
      touchStart(e) {
        this.startX = e.touches[0].pageX
        this.startY = e.touches[0].clientY
        this.startTime = new Date().getTime()
        this.screenWidth = document.documentElement.clientWidth
      },
      touchEnd(e) {
        this.endX = e.changedTouches[0].pageX
        this.endY = e.changedTouches[0].clientY
        this.endTime = new Date().getTime()
        this.slideTime = this.endTime - this.startTime
        this.slideX = this.endX - this.startX
        this.slideY = Math.abs(this.endY - this.startY)
        const isSlideFromLeftEdge = this.startX < 40
        if (
          !this.isWatchLayout &&
          isSlideFromLeftEdge &&
          this.slideX > 60 &&
          this.slideTime < 500 &&
          this.slideX > this.slideY &&
          !this.isSwipeBackDisabledPath(this.$route.path)
        ) {
          this.$router.go(-1)
        }
      },
    },
  }
</script>
<style lang="less">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #fff;
    text-align: center;
    color: #2c3e50;
    width: 100vw;
    font-size: 0.16rem;
    font-weight: 500;
  }
  #app.is-watch {
    // background: #000;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    select,
    textarea,
    input {
      font-size: 16px;
    }
  }
  html {
    font-size: 12px;
    line-height: 12px;
  }
  .waitingB {
    position: absolute !important;
    top: 0;
  }
  .van-notify.biochem-notify {
    background: linear-gradient(90deg, #ffb703 0%, #ff8f1f 100%);
    color: #1f2937;
    font-weight: 700;
    letter-spacing: 0.01rem;
    box-shadow: 0 0.08rem 0.18rem rgba(255, 143, 31, 0.45);
    padding: 0.14rem 0.16rem;
    text-align: left;
    cursor: pointer;
    border-left: 0.04rem solid #ff6b00;
  }
</style>
